import { TodoTask } from '../../src/todolist/add-todo/addTodoList';
import { NoteProps } from '../../src/note/note';
import { useAuthStore } from './auth';

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || 'https://backend.iceking.wtf/api';

const getAuthHeaders = () => {
  const token = useAuthStore.getState().token;
  return token ? { 'Authorization': `Bearer ${token}` } : {};
};

const getHeaders = () => ({
  'Content-Type': 'application/json',
  ...getAuthHeaders(),
});

export const todoApi = {
  // Get all todos
  async getAllTodos(): Promise<TodoTask[]> {
    const response = await fetch(`${API_BASE_URL}/todos`, {
      headers: getHeaders(),
    });
    if (!response.ok) {
      throw new Error('Failed to fetch todos');
    }
    return response.json();
  },

  // Create a new todo
  async createTodo(todo: Omit<TodoTask, 'id'>): Promise<TodoTask> {
    const response = await fetch(`${API_BASE_URL}/todos`, {
      method: 'POST',
      headers: getHeaders(),
      body: JSON.stringify(todo),
    });
    if (!response.ok) {
      throw new Error('Failed to create todo');
    }
    return response.json();
  },

  // Update a todo
  async updateTodo(id: string, updates: Partial<TodoTask>): Promise<TodoTask> {
    const response = await fetch(`${API_BASE_URL}/todos/${id}`, {
      method: 'PATCH',
      headers: getHeaders(),
      body: JSON.stringify(updates),
    });
    if (!response.ok) {
      throw new Error('Failed to update todo');
    }
    return response.json();
  },

  // Delete a todo
  async deleteTodo(id: string): Promise<void> {
    const response = await fetch(`${API_BASE_URL}/todos/${id}`, {
      method: 'DELETE',
      headers: getHeaders(),
    });
    if (!response.ok) {
      throw new Error('Failed to delete todo');
    }
  },
};

export const noteApi = {
  // Get all notes
  async getAllNotes(): Promise<NoteProps[]> {
    const response = await fetch(`${API_BASE_URL}/notes`, {
      headers: getHeaders(),
    });
    if (!response.ok) {
      throw new Error('Failed to fetch todos');
    }
    return response.json();
  },

  // Create a new note
  async createNote(note: Omit<NoteProps, 'id'>): Promise<NoteProps> {
    const response = await fetch(`${API_BASE_URL}/notes`, {
      method: 'POST',
      headers: getHeaders(),
      body: JSON.stringify(note),
    });
    if (!response.ok) {
      throw new Error('Failed to create note');
    }
    return response.json();
  },

  // Update a todo
  async updateNote(id: string, updates: Partial<NoteProps>): Promise<NoteProps> {
    const response = await fetch(`${API_BASE_URL}/notes/${id}`, {
      method: 'PATCH',
      headers: getHeaders(),
      body: JSON.stringify(updates),
    });
    if (!response.ok) {
      throw new Error('Failed to update note');
    }
    return response.json();
  },

  // Delete a note
  async deleteNote(id: string): Promise<void> {
    const response = await fetch(`${API_BASE_URL}/notes/${id}`, {
      method: 'DELETE',
      headers: getHeaders(),
    });
    if (!response.ok) {
      throw new Error('Failed to delete note');
    }
  },
};